import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from 'constants/apiConfig';

export const keys = {
  customTemplates: 'customTemplates',
};

export const useFetchCustomTemplates = (tenantId: UUID) => {
  return useQuery({
    queryKey: [keys.customTemplates, tenantId],
    queryFn: async () => {
      const response = await axios(
        `${config.apiGateway.customTeamTemplates}/${tenantId}`,
        {
          method: 'GET',
        }
      );
      return response?.data;
    },
  });
};
